module.exports = __webpack_public_path__ + "static/media/feature_flag_main_visual.843a2555.png";